import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';
import { DURATION_MINUTES } from '@/services/rateLimiter';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

// Helper function to format reset time based on duration
export const formatResetTime = (resetDate: Date) => {
  if (DURATION_MINUTES < 60) {
    // For short durations (minutes), show full date and time
    return resetDate.toLocaleString();
  } else if (DURATION_MINUTES < 24 * 60) {
    // For durations less than a day, show time
    return `today at ${resetDate.toLocaleTimeString()}`;
  } else {
    // For day+ durations, show date only
    return (
      resetDate.toLocaleDateString() + ' at ' + resetDate.toLocaleTimeString()
    );
  }
};
